// extracted by mini-css-extract-plugin
var _1 = "ControlBarPopOver-module__animateUploadProgressBarWidth--ds4zX";
var _2 = "ControlBarPopOver-module__animatedBackground--tmvxj";
var _3 = "ControlBarPopOver-module__floatingContainer--nKP4z";
var _4 = "ControlBarPopOver-module__inner--I3xgx";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "floatingContainer", _4 as "inner" }
